import React, { Component } from 'react';
import { showModal } from 'shared/actions/ModalActions';
import AnswerOption from './AnswerOption';
import { RawPlainSelect } from 'shared/containers/portal_layout/HForm/PlainSelectField';
import HasConditionalIndicator from './HasConditionalIndicator';

const newAnswerOption = () => ({
  value: '',
});

const elementTypeOptions = [
  { name: 'Check Box', value: 'checkbox' },
  { name: 'Radio', value: 'radio' },
  { name: 'Select', value: 'select' },
  { name: 'Fancy Select', value: 'fancy_select' },
  { name: 'Text Input', value: 'text_input' },
  { name: 'Text Area', value: 'text_area' },
  { name: 'ICD-10 Input', value: 'icd_10_input' },
  { name: 'Tooth Selector', value: 'tooth_selector' },
  { name: 'Signature', value: 'signature' },
];

class Question extends Component {
  constructor(props, context) {
    super(props, context);
    this.updateAnswerOption = this.updateAnswerOption.bind(this);
    this.updatePrompt = this.updatePrompt.bind(this);
    this.updateQuestionType = this.updateQuestionType.bind(this);
    this.updateRequired = this.updateRequired.bind(this);
    this.updateDefaultVisibility = this.updateDefaultVisibility.bind(this);
    this.promoteAnswerOption = this.promoteAnswerOption.bind(this);
    this.demoteAnswerOption = this.demoteAnswerOption.bind(this);
    this.removeAnswerOption = this.removeAnswerOption.bind(this);
    this.addAnswerOption = this.addAnswerOption.bind(this);
    this.updateConditionalGroup = this.updateConditionalGroup.bind(this);
    this.removeConditionalGroup = this.removeConditionalGroup.bind(this);
    this.showConditionalGroupModal = this.showConditionalGroupModal.bind(this);
  }

  updateAnswerOption(idx, newValue) {
    const newAnswerOptions = this.props.question.answerOptions.map((answerOption, i) => {
      if (i === idx) return newValue;
      return answerOption;
    });
    this.props.onChange({ ...this.props.question, answerOptions: newAnswerOptions });
  }

  updatePrompt(e) {
    this.props.onChange({ ...this.props.question, prompt: e.target.value });
  }

  updateQuestionType(type) {
    this.props.onChange({ ...this.props.question, elementType: type });
  }

  updateRequired(e) {
    this.props.onChange({ ...this.props.question, required: e.target.checked });
  }

  updateDefaultVisibility(e) {
    this.props.onChange({ ...this.props.question, defaultVisible: e.target.checked });
  }

  promoteAnswerOption(idx) {
    if (idx > 0) {
      const answerOptions = this.props.question.answerOptions;
      this.props.onChange({
        ...this.props.question,
        answerOptions: answerOptions
          .slice(0, idx - 1)
          .concat([answerOptions[idx], answerOptions[idx - 1]])
          .concat(answerOptions.slice(idx + 1)),
      });
    }
  }

  demoteAnswerOption(idx) {
    if (this.props.question.answerOptions[idx + 1]) {
      this.promoteAnswerOption(idx + 1);
    }
  }

  addAnswerOption() {
    this.props.onChange({
      ...this.props.question,
      answerOptions: this.props.question.answerOptions.concat(newAnswerOption()),
    });
  }

  removeAnswerOption(idx) {
    this.props.onChange({
      ...this.props.question,
      answerOptions: this.props.question.answerOptions.filter((_answerOption, i) => i !== idx),
    });
  }

  updateConditionalGroup(data) {
    this.props.onChange({
      ...this.props.question,
      visibilityConditionalGroup: data.conditionalGroup,
      visibilityThenAction: data.thenAction,
    });
  }

  removeConditionalGroup() {
    this.props.onChange({
      ...this.props.question,
      visibilityConditionalGroup: null,
      visibilityThenAction: null,
    });
  }

  showConditionalGroupModal() {
    showModal({
      name: 'questionnaireItemConditionalGroupModal',
      conditionalGroup: this.props.question.visibilityConditionalGroup,
      thenAction: this.props.question.visibilityThenAction,
      updateConditionalGroup: this.updateConditionalGroup,
      removeConditionalGroup: this.removeConditionalGroup,
      rulableFields: this.props.rulableFields,
    });
  }

  render() {
    const { question, remove, promote, demote, errorCollection } = this.props;
    const hasConditional = !!question.visibilityConditionalGroup;

    return (
      <div className="ec-form-question clearfix">
        {errorCollection && errorCollection.length ? (
          <div style={{ color: 'red' }}>
            <ul>
              {errorCollection.map(error => (
                <li>{error.error}</li>
              ))}
            </ul>
          </div>
        ) : null}
        <div className="question-left">
          <div className="btn-group">
            <button
              alt="move up"
              className="btn btn-mini up-question"
              type="button"
              onClick={promote}
            >
              <i className="icon-arrow-up" />
            </button>
            <button
              alt="move down"
              className="btn btn-mini up-question"
              type="button"
              onClick={demote}
            >
              <i className="icon-arrow-down" />
            </button>
            <button className="btn btn-danger btn-mini" type="button" onClick={remove}>
              <i className="icon-remove icon-white" />
            </button>
          </div>

          <div className="question-prompt-group">
            <label className="promp-label">
              Question:
              <div className="prompt-input">
                <input type="text" onChange={this.updatePrompt} value={question.prompt} />
              </div>
            </label>
          </div>
          <label>
            Required:{' '}
            <input type="checkbox" checked={!!question.required} onChange={this.updateRequired} />
          </label>
          <label>
            Default Visible:{' '}
            <input
              type="checkbox"
              checked={!!question.defaultVisible}
              onChange={this.updateDefaultVisibility}
            />
          </label>
          <div>{hasConditional ? <HasConditionalIndicator /> : 'Not conditional'}</div>
          <button onClick={this.showConditionalGroupModal} className="btn btn-mini" type="button">
            {hasConditional ? 'Edit Conditional' : 'Add Conditional'}
          </button>
        </div>

        <div className="question-right">
          <div className="question-type-select-group">
            <div className="question-control-group">
              <label className="question-control-label">Question Type:</label>
              <div className="question-controls">
                <RawPlainSelect
                  data-spec-class="question-type"
                  value={question.elementType}
                  onChange={this.updateQuestionType}
                  options={elementTypeOptions}
                  labelKey="name"
                  valueKey="value"
                />
              </div>
            </div>
          </div>

          <div className="answer-options">
            <div className="question-control-group">
              <label className="question-control-label">Answer Options:</label>
              <div className="question-controls">
                <button className="btn" type="button" onClick={this.addAnswerOption}>
                  Add Option
                </button>
              </div>
            </div>

            <div className="options">
              {question.answerOptions &&
                question.answerOptions.map((answerOption, idx) => (
                  <AnswerOption
                    key={idx}
                    answerOption={answerOption}
                    onChange={newValue => this.updateAnswerOption(idx, newValue)}
                    promote={() => this.promoteAnswerOption(idx)}
                    demote={() => this.demoteAnswerOption(idx)}
                    remove={() => this.removeAnswerOption(idx)}
                  />
                ))}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Question;
